export default __webpack_public_path__ + "static/media/controversial.7f92ecd3.svg";